import { React, useEffect, useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import Loader from "../components/Loader";
import { setUsers } from "../slices/userSelfSlice";
import Message from "../components/Message";
import { useGetUsersSelfQuery } from "../slices/usersSelfSlice";
import UserSelfProfileScreen from "./UserSelfProfileScreen";
import preferredLanguage from "../assets/preferredLanguage.json";

const PendingRegsScreen = () => {
  const [searchBy, setSearchBy] = useState("Id");
  const [approveEnabled, setApproveEnabled] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { userInfo } = useSelector((state) => state.auth);
  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";
  const [userSelf, setUserSelf] = useState();

  const handleReview = (val) => {
    setApproveEnabled(true);
    setUserSelf(val);
  };

  const filterOptions = ["Id", "Name", "Mobile"];

  const dispatch = useDispatch();

  const searchOptions = {
    Id: "_id",
    Name: "firstName",
    Mobile: "mobileNumber",
  };
  let {
    data: users,
    isLoading,
    refetch,
    error,
  } = useGetUsersSelfQuery({
    token: userInfo.token,
  });

  const [totalUsers, setTotalUsers] = useState(
    isLoading ? [] : users ? users : []
  );
  const [usersToList, setUsersToList] = useState(
    isLoading ? [] : users ? users : []
  );
  // const [activeUsers, setActiveUsers] = useState("");
  // const [inActiveUsers, setInactiveUsers] = useState("");
  const [maleUsers, setMaleUsers] = useState("");
  const [femaleUsers, setfemaleUsers] = useState("");
  const [seniorCitizens, setSeniorCitizens] = useState("");
  const [ptEnablesUsers, setPtEnablesUsers] = useState("");

  useEffect(() => {
    refetch();
    if (users) dispatch(setUsers(users));
    setTotalUsers(isLoading ? [] : users ? users : 0);
    setUsersToList(isLoading ? [] : users ? users : 0);

    setMaleUsers(
      isLoading
        ? []
        : users
        ? users.filter(
            (user) => user["gender"].toString().toLowerCase() === "male"
          )
        : []
    );

    setfemaleUsers(
      isLoading
        ? []
        : users
        ? users.filter(
            (user) => user["gender"].toString().toLowerCase() === "female"
          )
        : []
    );
    setSeniorCitizens(
      isLoading
        ? []
        : users
        ? users.filter(
            (user) =>
              50 <
              Math.floor(
                (new Date() - new Date(user["dateOfBirth"])) /
                  (365.25 * 24 * 60 * 60 * 1000)
              )
          )
        : []
    );

    setPtEnablesUsers(
      isLoading ? [] : users ? users.filter((user) => user["ptEnabled"]) : []
    );
  }, [refetch, dispatch, users, approveEnabled]);

  const handleSelect = (e) => {
    setSearchBy(e.target.value);
  };
  const onSearchTextChange = (val) => {
    setSearchValue(val);
    const searchedUsers = users?.filter((user) => {
      let userData;
      if (searchBy === "Name") {
        userData = String(user[searchOptions[searchBy]]).toLowerCase();
      } else {
        userData = String(user[searchOptions[searchBy]]);
      }
      return userData.includes(val.toLowerCase());
    });
    setUsersToList(searchedUsers);
  };

  const handleFilterSelecttion = (val) => {
    setUsersToList(val);
  };

  return (
    <>
      <label>
        <strong>{preferredLanguage[selectedLanguage]?.pendingReg}</strong>
      </label>
      {approveEnabled ? (
        <UserSelfProfileScreen
          user={userSelf}
          setApproveEnabled={setApproveEnabled}
        />
      ) : (
        <>
          <Row
            className="mb-1"
            style={{
              justifyContent: "center",
              padding: "auto",
              margin: "auto",
              width: "95%",
              alignItems: "center",
            }}
          >
            <Col>
              <Form.Group as={Row} className="my-2" controlId="filterBy">
                <Form.Select
                  id="filterBy"
                  value={searchBy}
                  onChange={handleSelect}
                >
                  {filterOptions.map((e) => (
                    <option key={e} value={e}>
                      {e}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Row} className="my-2" controlId="visitorMobile">
                <Form.Control
                  type="text"
                  placeholder="type here to search"
                  value={searchValue}
                  onChange={(e) => onSearchTextChange(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            {/* <Col>
              <Form.Group as={Row} className="my-2" controlId="visitorMobile">
                <Button
                  type="date"
                  placeholder="2023-11-27"
                  value={searchValue}
                  onChange={(e) => onSearchTextChange(e.target.value)}
                >
                  Search
                </Button>
              </Form.Group>
            </Col> */}
          </Row>
          <Row
            className="mb-3"
            style={{ margin: "auto", width: "95%", justifyContent: "center" }}
          >
            <Button
              className="marginPointEight fifteenWidth buttonGreen numbersButtonAssociateProfile"
              onClick={() => handleFilterSelecttion(totalUsers)}
            >
              {preferredLanguage[selectedLanguage]?.commonTitles.total}{" "}
              <strong> {totalUsers?.length}</strong>
            </Button>

            <Button
              className="marginPointOne fifteenWidth buttonOrange numbersButtonAssociateProfile"
              onClick={() => handleFilterSelecttion(maleUsers)}
            >
              {preferredLanguage[selectedLanguage]?.commonTitles.male}{" "}
              <strong> {maleUsers?.length}</strong>
            </Button>
            <Button
              className="marginPointOne fifteenWidth buttonOrchid numbersButtonAssociateProfile"
              onClick={() => handleFilterSelecttion(femaleUsers)}
            >
              {preferredLanguage[selectedLanguage]?.commonTitles.female}{" "}
              <strong> {femaleUsers?.length}</strong>
            </Button>
            <Button
              className="marginPointOne fifteenWidth buttonReddish numbersButtonAssociateProfile"
              onClick={() => handleFilterSelecttion(seniorCitizens)}
            >
              {preferredLanguage[selectedLanguage]?.commonTitles.seniors}{" "}
              <strong> {seniorCitizens?.length}</strong>
            </Button>
          </Row>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error}</Message>
          ) : (
            <div style={{ height: "100vh" }}>
              <div className="tableContainer">
                <Table
                  striped
                  bordered
                  hover
                  responsive="sm"
                  className="table-custom"
                >
                  <thead className={`${userInfo.themeColor}ThemeThead`}>
                    <tr>
                      <th>Name</th>
                      <th>Id</th>
                      <th>Subscription</th>
                      <th></th>
                    </tr>
                  </thead>
                  {usersToList ? (
                    <tbody className={`${userInfo.themeColor}ThemeTbody`}>
                      {usersToList.map((user) => (
                        <tr key={user.userId}>
                          <td>{user.firstName} </td>
                          <td>{user.userId}</td>
                          <td>{user.subscriptionType}</td>
                          <td>
                            <button
                              style={{ borderRadius: "8%" }}
                              onClick={() => handleReview(user)}
                            >
                              Register
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <Message>No users Available</Message>
                  )}
                </Table>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PendingRegsScreen;
